export var InputSize = /*#__PURE__*/ function(InputSize) {
    InputSize["s"] = "s";
    InputSize["m"] = "m";
    InputSize["l"] = "l";
    return InputSize;
}({});
export var InlineInputSize = /*#__PURE__*/ function(InlineInputSize) {
    InlineInputSize["m"] = "m";
    InlineInputSize["l"] = "l";
    return InlineInputSize;
}({});
export var InputVariants = /*#__PURE__*/ function(InputVariants) {
    InputVariants["primary"] = "primary";
    InputVariants["error"] = "error";
    return InputVariants;
}({});
export var Placement = /*#__PURE__*/ function(Placement) {
    Placement["left"] = "left";
    Placement["right"] = "right";
    return Placement;
}({});
export var ResizeDirection = /*#__PURE__*/ function(ResizeDirection) {
    ResizeDirection["vertical"] = "vertical";
    ResizeDirection["horizontal"] = "horizontal";
    ResizeDirection["both"] = "both";
    ResizeDirection["none"] = "none";
    return ResizeDirection;
}({});
